import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";

export default forwardRef(function BlackoutDayForm(
  {
    data = {},
    onChange = () => {},
    onError = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        onError={onError}
        type={type}
        layout={[
          {
            name: "name",
            label: "Name",
            type: "text",
            size: "small",
          },
          {
            name: "blackout_day",
            label: "Blackout Day",
            type: "date",
            size: "small",
            required: true,
          },
        ]}
        isLabel
        fullWidth={true}
        direction="column"
        spacing={2}
      />
    </div>
  );
});
